import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { SensorDataRestoringRequestStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter = {
  page: 0,
  limit: 50,
  search: "",
  hospital_id: null,
};

export const initialState: SensorDataRestoringRequestStateType = {
  requests: [],
  requestsTotal: 0,
  filter: { ...defaultFilter },
};

const reducer = createReducer<SensorDataRestoringRequestStateType, Action>(initialState)
  .handleAction(actions.getSensorDataRestoringRequests.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.requests = !is_clear ? [...nextState.requests, ...rows] : [...rows];
      nextState.requestsTotal = count;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.createSensorDataRestoringRequest.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.requests = [action.payload.restoring_request, ...state.requests];
      nextState.requestsTotal = state.requestsTotal + 1;
    }),
  )
  .handleAction(actions.getSensorDataRestoringRequest.success, (state, action) =>
    produce(state, (nextState) => {
      const newRestoringRequest = action.payload;
      const oldRequests = [...state.requests];
      if (newRestoringRequest) {
        const oldRestoringRequestIndex = oldRequests.findIndex((r) => r.id === newRestoringRequest.id);
        if (oldRestoringRequestIndex !== -1) {
          oldRequests[oldRestoringRequestIndex] = newRestoringRequest;
        }
      }

      nextState.requests = [...oldRequests];
    }),
  )
  .handleAction(actions.restoreSensorDataRestoringRequest.success, (state, action) =>
    produce(state, (nextState) => {
      const newRestoringRequest = action.payload.restoring_request;
      const oldRequests = [...state.requests];
      if (newRestoringRequest) {
        const oldRestoringRequestIndex = oldRequests.findIndex((r) => r.id === newRestoringRequest.id);
        if (oldRestoringRequestIndex !== -1) {
          oldRequests[oldRestoringRequestIndex] = newRestoringRequest;
        }
      }

      nextState.requests = [...oldRequests];
    }),
  )
  .handleAction(actions.deleteSensorDataRestoringRequest.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.requests = state.requests.filter((r) => r.id !== action.payload.restoring_request_id);
    }),
  );

export { reducer as SensorDataRestoringRequestReducer };
